/**
 * A random key for an idempotent request (a retry with the same key never posts twice).
 * `crypto.randomUUID` exists only in secure contexts (HTTPS or localhost); a phone on the office
 * network over plain HTTP has `crypto.getRandomValues` alone, so the key is built from it there.
 */
export function requestKey(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
